export default "__VITE_ASSET__Js85AJMy__"